import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { ConfirmDialogService, ConfirmDialogData, DialogState } from '@core/services/confirm-dialog.service';
import { HugeiconsIconComponent } from '@hugeicons/angular';
import { AlertCircleIcon, CheckmarkCircle01Icon, InformationCircleIcon, Alert02Icon } from '@hugeicons/core-free-icons';

@Component({
    selector: 'app-confirm-dialog',
    standalone: true,
    imports: [CommonModule, HugeiconsIconComponent],
    templateUrl: './confirm-dialog.component.html',
    styleUrl: './confirm-dialog.component.scss'
})
export class ConfirmDialogComponent implements OnInit, OnDestroy {
    isOpen = false;
    data: ConfirmDialogData = {
        title: 'Confirm Action',
        message: 'Are you sure you want to proceed?',
        type: 'warning'
    };

    private subscription: Subscription | null = null;

    constructor(private confirmService: ConfirmDialogService) { }

    ngOnInit(): void {
        this.subscription = this.confirmService.dialogState$.subscribe((state: DialogState) => {
            this.isOpen = state.isOpen;
            if (state.data) {
                this.data = { ...this.data, ...state.data };
            }
        });
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    close(confirmed: boolean) {
        this.confirmService.close(confirmed);
    }

    getIcon(): any {
        switch (this.data.type) {
            case 'danger': return AlertCircleIcon;
            case 'success': return CheckmarkCircle01Icon;
            case 'info': return InformationCircleIcon;
            case 'warning':
            default: return Alert02Icon;
        }
    }

    getConfirmButtonClass(): string {
        switch (this.data.type) {
            case 'danger': return 'btn-danger';
            case 'success': return 'btn-success'; // Assuming btn-success exists or falls back
            case 'info': return 'btn-primary';
            case 'warning':
            default: return 'btn-primary';
        }
    }
}
